import React, { useContext, createContext } from 'react'; // eslint-disable-line

interface TipsterRouteInfoContent {
  adjustTracker: string;
  tipsterID: string;
  tipsterSlug: string;
}

export const TipsterRouteInfoContext = createContext<TipsterRouteInfoContent>({
  adjustTracker: '',
  tipsterID: '',
  tipsterSlug: '',
});

export const useTipsterRouteInfoContext = () =>
  useContext(TipsterRouteInfoContext);
